import { render } from "./ShowRule.vue?vue&type=template&id=2493dba8&scoped=true"
import script from "./ShowRule.vue?vue&type=script&lang=js"
export * from "./ShowRule.vue?vue&type=script&lang=js"

import "./ShowRule.vue?vue&type=style&index=0&id=2493dba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2493dba8"]])

export default __exports__